import React, { FunctionComponent, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCompanies,
  selectCompanies,
} from "../../features/company/companySlice";
import { MainLayout } from "../common/Layouts/Main";
import { CompanySideFilter } from "./CompanySideFilter";
import styles from "./index.module.scss";
import { Settings } from "./Settings";
import { fetchGamification } from "../../features/gamification/gamificationSlice";
import { getTranslations } from "../../features/translations/translationsUtils";

export const Gamification: FunctionComponent = () => {
  const [companyId, setCompanyId] = useState<string | null>(null);
  const companies = useSelector(selectCompanies);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCompanies());
  }, [dispatch]);

  useEffect(() => {
    if (companyId) {
      dispatch(fetchGamification(companyId));
    }
  }, [companyId, dispatch])

  return (
    <MainLayout
      title={getTranslations('GAMIFICATION_TITLE')}
      titleContainerClass={styles.header}
      breadcrumbs={[getTranslations('GAMIFICATION_TITLE')]}
    >
      <div className={styles.container}>
        <div>
          <div className={styles.companyFilterContainer}>
            <CompanySideFilter
              list={companies}
              companyId={companyId}
              setCompanyId={(companyId: string) => {
                setCompanyId(companyId);
              }}
            />
          </div>
        </div>
        <div className={styles.innerContainer}>
            {companyId ? <Settings companyId={companyId} /> : null}
        </div>
      </div>
    </MainLayout>
  );
};
